@if (market) {
  <div class="container single-view" id="edit-market">
    <div class="row">
      <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
        <div id="pre-header-wr">
          <a data-testid="back-btn" appBack [fallbackUrl]="'/markets/' + marketId" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'MARKETS.BTN_BACK_TO_MARKET' | translate }}</a>
        </div>
      </div>
      <div class="col-12">
        <div id="view-header-wr">
          <div class="title-wr">
            <h1 edit-testid="edit-market-title" class="section-title">{{ 'MARKET_UPDATE.TITLE' | translate }}</h1>
          </div>
        </div>
        <hr role="presentation" class="w-full mb-3 mt-6 border-t">
        <div class="view-content-wr">
          <div class="row">
            <div class="flex flex-col col-12 mb-2 text-wr">
              <!-- main content -->
              <form class="mt-0" [formGroup]="marketForm" data-testid="edit-market-form">
                <div class="row">
                  <div class="flex flex-col col-12 mb-4">
                    <h2 data-testid="edit-markets-details-title" class="border-b pb-3">{{ 'MARKET_UPDATE.MARKET_DETAILS' | translate }}</h2>
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-market-field-name" class="block text-sm" for="name">{{ 'MARKET_UPDATE.NAME' | translate }} <i class="icon-required-field"></i></label>
                    <input data-testid="edit-market-name-input" type="text" formControlName="name" autocomplete="off">
                    @if (marketForm.get('name')?.invalid && marketForm.get('name')?.touched) {
                      <small data-testid="name-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-market-field-code" class="block text-sm" for="code">{{ 'MARKET_UPDATE.CODE' | translate }}</label>
                    <input data-testid="edit-market-code-input" type="text" formControlName="code" autocomplete="off">
                    @if (marketForm.get('code')?.invalid && marketForm.get('code')?.touched) {
                      <small data-testid="code-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-market-field-warrantyduration" class="block text-sm" for="warrantyDurationMonths">{{ 'MARKET_UPDATE.WARRANTY_DEFAULT_DURATION' | translate }} <i class="icon-required-field"></i> <i class="pi pi-question-circle" pTooltip="{{ 'TOOLTIP.DURATION_IN_MONTHS' | translate }}"
                  tooltipPosition="top"></i></label>
                  <input data-testid="edit-market-warrantyduration-input" type="number" formControlName="warrantyDurationMonths" autocomplete="off">
                  @if (marketForm.get('warrantyDurationMonths')?.invalid && marketForm.get('warrantyDurationMonths')?.touched) {
                    <small data-testid="warrantyduration-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <span data-testid="edit-market-field-hasParent" class="block text-sm mb-3" for="hasParent">{{ 'MARKET_UPDATE.HAS_PARENT' | translate }}</span>
                  <label data-testid="edit-market-has-parent-yes-label" class="inline-flex mr-6">
                    <p-radioButton data-testid="edit-market-has-parent-yes" name="hasParentMarket" value="true" formControlName="hasParentMarket" inputId="yes" />
                    <span for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                  </label>
                  <label data-testid="edit-market-has-parent-no-label" class="inline-flex mr-2">
                    <p-radioButton data-testid="edit-market-has-parent-no" name="hasParentMarket" value="false" formControlName="hasParentMarket" inputId="no" />
                    <span for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                  </label>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3" [ngClass]="{'disabled': marketForm.get('hasParentMarket')?.value == 'false'}">
                  <label class="block text-sm" for="parentMarket">{{ 'MARKET_UPDATE.PARENT_MARKET' | translate }}</label>
                  <app-custom-dropdown
                    data-testid="parentmarket"
                    [placeholder]="'MARKET_UPDATE.SELECT_PARENT_PLACEHOLDER' | translate"
                    optionLabel="text"
                    optionValue="id"
                    [isMultiselect]="false"
                    [showSelectionChips]="true"
                    [showClear]="true"
                    [searchMode]="'remote'"
                    [pageSize]="marketsRowsPerPageOption"
                    [totalCount]="marketsTotalRecords"
                    [totalPages]="getMarketsTotalPages()"
                    [options]="marketsList"
                    formControlName="market"
                    (onLazyLoad)="onLazyLoadMarkets($event)">
                  </app-custom-dropdown>
                  @if (marketForm.errors?.['requiredMarket'] && isMarketRequired()) {
                    <small data-testid="parent-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
              </div>
              <div class="row">
                <div class="col-12 mt-6 mb-4 pt-8 border-t">
                  <div class="flex items-center justify-end gap-3">
                    <button data-testid="edit-market-update-market-button" class="btn primary-btn" [disabled]="marketForm.invalid" (click)="submitForm()">{{ 'MARKET_UPDATE.BTN_UPDATE_MARKET' | translate }}</button>
                  </div>
                </div>
              </div>
            </form>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}
